var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy271(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80C4,6.5,6.5,4,9.6,4 H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M33.4,40.6c3.9,0,7.1,3.2,7.1,7.1c0,3.9-3.2,7.1-7.1,7.1c-3.9,0-7.1-3.2-7.1-7.1 C26.3,43.8,29.5,40.6,33.4,40.6 M33.4,35.6c-6.7,0-12.1,5.4-12.1,12.1c0,6.7,5.4,12.1,12.1,12.1s12.1-5.4,12.1-12.1 C45.4,41,40,35.6,33.4,35.6L33.4,35.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M65.8,40.3c3.9,0,7.1,3.2,7.1,7.1s-3.2,7.1-7.1,7.1c-3.9,0-7.1-3.2-7.1-7.1S61.9,40.3,65.8,40.3 M65.8,35.3 c-6.7,0-12.1,5.4-12.1,12.1c0,6.7,5.4,12.1,12.1,12.1S77.9,54,77.9,47.4C77.9,40.7,72.5,35.3,65.8,35.3L65.8,35.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6255_6_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.6,
    cy: 29.6,
    rx: 8,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M51.4,37.1c0.5-0.5,0.8-1.1,0.8-1.9c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6c0,0.7,0.3,1.4,0.8,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M47.8,22c-0.5,0.5-0.8,1.1-0.8,1.9c0,1.4,1.2,2.6,2.6,2.6c1.5,0,2.6-1.2,2.6-2.6c0-0.7-0.3-1.4-0.8-1.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M42.1,31.4c0.5,0.5,1.1,0.8,1.9,0.8c1.4,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6c-0.7,0-1.4,0.3-1.9,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M57.1,27.7c-0.5-0.5-1.1-0.8-1.9-0.8c-1.4,0-2.6,1.2-2.6,2.6c0,1.5,1.2,2.6,2.6,2.6c0.7,0,1.4-0.3,1.9-0.8"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6255_4_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.6,
    cy: 65.1,
    rx: 8,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M51.4,72.6c0.5-0.5,0.8-1.1,0.8-1.9c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6c0,0.7,0.3,1.4,0.8,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M47.8,57.5C47.3,58,47,58.7,47,59.4c0,1.4,1.2,2.6,2.6,2.6c1.5,0,2.6-1.2,2.6-2.6c0-0.7-0.3-1.4-0.8-1.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M42.1,66.9c0.5,0.5,1.1,0.8,1.9,0.8c1.4,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6c-0.7,0-1.4,0.3-1.9,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M57.1,63.2c-0.5-0.5-1.1-0.8-1.9-0.8c-1.4,0-2.6,1.2-2.6,2.6c0,1.5,1.2,2.6,2.6,2.6c0.7,0,1.4-0.3,1.9-0.8"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M76.4,25.7l1.8-3l-6-5.3l-2.6,1.9c-5.6-4-12.5-6.4-20-6.4c-7.5,0-14.4,2.4-20,6.4L27,17.4l-6,5.3l1.8,3 c-4.8,5.9-7.7,13.4-7.7,21.6c0,19,15.4,34.4,34.4,34.4c19,0,34.4-15.4,34.4-34.4C84,39.1,81.2,31.6,76.4,25.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy271);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-271.0606a4fdc5f10cc2aefec5041b5d0550.svg";
export { ForwardRef as ReactComponent };